module.exports = __webpack_public_path__ + "static/media/hover.61ce8054.svg";